import { CREATE_BUTTON_LABELS, CREATE_OPTION_KEYS } from '../constants'

export const getCreateButtonOptions = () => [
  {
    label: CREATE_BUTTON_LABELS.BUTTON,
    route: 'buttons',
    key: CREATE_OPTION_KEYS.NEW_BUTTON,
    disable: false,
    disabledTooltip: CREATE_BUTTON_LABELS.COMING_SOON,
  },
  {
    label: CREATE_BUTTON_LABELS.LISTING_CARD,
    route: 'listing-card',
    key: CREATE_OPTION_KEYS.LISTING_CARD,
  },
  {
    label: CREATE_BUTTON_LABELS.STOREFRONT,
    route: '',
    key: CREATE_OPTION_KEYS.NEW_STOREFRONT,
    disable: true,
    disabledTooltip: CREATE_BUTTON_LABELS.COMING_SOON,
  },
]
